var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-scan-payment',{staticClass:"pt-scan-payment__withData",attrs:{"companyList":_vm.companyList,"exportLoading":_vm.exportLoading},on:{"scanPaymentExport":_vm.scanPaymentExport}})}
var staticRenderFns = []

export { render, staticRenderFns }